export const enum PS_EVENTS {
	AUTO_SCROLL = 'AUTO_SCROLL',
	INPUT_FOCUS = 'INPUT_FOCUS',
	NO_HOTEL_RATES = 'NO_HOTEL_RATES',
	SELECTED_ITEM_CHANGED = 'SELECTED_ITEM_CHANGED',
	FIELD_ERROR = 'FIELD_ERROR',
	HANDLE_SEARCH = 'HANDLE_SEARCH',
	LIST_VIEW = 'LIST_VIEW',
	FULL_SCREEN_MAP = 'FULL_SCREEN_MAP',
}
